import React, {Component} from 'react'
import {Card, Button} from 'antd';
import '../scss/OtherListItem.scss';
const { Meta } = Card;
import {string} from '@/utils/string';
import {toBookCover, toBookRead} from '@/utils/string'

export class OtherListItem extends Component {

  render() {
    let data = this.props.data
    let start = this.props.start
    let tpl = []
    if (data != null && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        tpl.push(
          <Card
            hoverable={false}
            bordered={false}
            className="other-list-item padded-t-15 padded-b-15"
            cover={<img alt={data[i].articlename} src={data[i].cover}/>}
          >
            <Meta title={data[i].articlename} description={string.truncate(data[i].intro, 30, '...')}/>
            <div><Button className="btn margin-t-15" size="large" block={true} onClick={() => {
              toBookCover(data[i].articleid)
            }}>免费试读</Button></div>
          </Card>
        )
      }
    }

    return (
      <div>
        {tpl}
      </div>
    );
  }
}

export default OtherListItem
